import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaLabelFn = /* @__PURE__ */ createRecipe('textarea-label', {
  "size": "l"
}, [])

const textareaLabelVariantMap = {
  "size": [
    "l",
    "m"
  ]
}

const textareaLabelVariantKeys = Object.keys(textareaLabelVariantMap)

export const textareaLabel = /* @__PURE__ */ Object.assign(memo(textareaLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaLabel',
  __getCompoundVariantCss__: textareaLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaLabelVariantKeys,
  variantMap: textareaLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaLabelVariantKeys)
  },
  getVariantProps: textareaLabelFn.getVariantProps,
})